<template>
  <div
    class="usernameWrapper"
    :data-test-id="$testId('usernameWrapper')"
  >
    <ButtonLink
      class="alignLeft"
      :data-test-id="$testId('userFullNameLink')"
      :text="userFullNameToDisplay"
      @click="handleUsernameClick"
    />

    <ButtonLink
      :class="['alignLeft', 'username']"
      :data-test-id="$testId('usernameLink')"
      :text="username"
      @click="handleUsernameClick"
    />
  </div>
</template>

<script>
import {
  ButtonLink,
} from '@jumpcloud/ui-components';
import { passwordManagerRoutes } from 'client/PasswordManager/PasswordManagerConstants';
import Util from 'client/util/Util';

export default {
  name: 'PasswordManagerUsernameLink',

  components: {
    ButtonLink,
  },

  Util,

  props: {
    id: {
      type: String,
      required: true,
    },

    userFullName: {
      type: String,
      required: false,
      default: '',
    },

    username: {
      type: String,
      required: true,
    },
  },

  computed: {
    userFullNameToDisplay() {
      return this.userFullName?.trim() || '-';
    },
  },

  methods: {
    handleUsernameClick() {
      this.$options.Util.redirect(`#${passwordManagerRoutes.userDetails(this.id)}`);
    },
  },
};
</script>

<style scoped>
.alignLeft {
  text-align: left;
}

.username {
  --button-font-size: var(--jcBodySmall);

  font-weight: 400;
}

.usernameWrapper {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}
</style>
